/* eslint-disable tss-unused-classes/unused-classes */

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    '& .MuiCheckbox-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  card: {
    background: theme.palette.background.default,
    border: `1px ${theme.palette.border.light} solid`,
    '& .MuiCardHeader-root': {
      height: 52,
      borderBottom: `1px solid ${theme.palette.border.light}`,
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    '& .MuiCardContent-root': {
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(3),
    },
    marginTop: 0,
    containerType: 'inline-size',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    '> .MuiStack-root': {
      flex: 1,
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '@container (max-width: 499px)': {
      '& > .MuiBox-root': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        // Hide vertical divider and show horizontal divider
        '& .MuiDivider-root[data-orientation="vertical"]': {
          display: 'none',
        },
        '& .MuiDivider-root[data-orientation="horizontal"]': {
          display: 'block',
          width: '100%',
          margin: `${theme.spacing(1)} 0`,
        },
      },
    },
    // Hide horizontal divider by default (only show when narrow)
    '& .MuiDivider-root[data-orientation="horizontal"]': {
      display: 'none',
    },
  },
  column: {
    paddingLeft: 42,
    marginTop: -4,
  },
  selected: {
    color: theme.palette.primary.main,
  },
  imgClass: {
    height: 16,
    width: 16,
    '&.singleIcon': {
      marginTop: -2,
    },
    alignSelf: 'center',
  },
  innerCard: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 12,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  notesTargetContainer: {
    display: 'flex',
    flex: 1,
    margin: 0,
    '.MuiInputBase-root': {
      background: theme.palette.background.paper,
      padding: `${theme.spacing(1)} !important`,
    },
    '& .error-Border': {
      border: `1px solid ${theme.palette.error.main} !important`,
    },
  },
  tagsTargetContainer: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 12,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  categoryTargetContainer: {
    '.MuiFilledInput-root': {
      height: '52px',
      boxSizing: 'border-box',
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.border.main}`,
      padding: theme.spacing(2),
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
      input: {
        padding: 0,
      },
      '& .MuiIconButton-root, & .MuiSvgIcon-root': {
        height: theme.spacing(3),
        width: theme.spacing(3),
      },
    },
  },
  usageTargetContainer: {
    '.MuiFilledInput-root': {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.border.main}`,
      padding: theme.spacing(2),
      height: '52px',
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
      '& .MuiSelect-icon': {
        height: theme.spacing(3),
        width: theme.spacing(3),
      },
    },
  },
  accountTargetContainer: {
    display: 'flex',
    flex: 1,
    '.MuiTextField-root': {
      flex: 1,
    },
  },
  accountTarget: {
    background: theme.palette.background.paper,
    alignItems: 'center',
    input: {
      padding: theme.spacing(2),
    },
  },
  payeeFieldContainer: {
    '.MuiTextField-root': {
      margin: 0,
      padding: 0,
      '.MuiFilledInput-root': {
        height: '52px',
        boxSizing: 'border-box',
        background: theme.palette.background.paper,
        padding: theme.spacing(2),
        input: {
          padding: 0,
        },
      },
    },
  },
  tagsFieldContainer: {
    '.MuiTextField-root': {
      margin: 0,
      padding: 0,
      '.MuiInputLabel-shrink': {
        display: 'none',
      },
      '.MuiFilledInput-root': {
        boxSizing: 'border-box',
        background: theme.palette.background.paper,
        padding: theme.spacing(2),
        input: {
          padding: 0,
        },
      },
    },
  },
  addBtnRow: {
    display: 'flex',
    flex: 1,
    gap: 16,
    '> hr': {
      flex: 1,
      alignSelf: 'center',
    },
  },
  formControlLabel: {
    margin: 0,
    padding: 0,
  },
  ruleAmount: {
    '.MuiInputBase-formControl': {
      background: theme.palette.background.paper,
    },
    '.MuiInputAdornment-filled': {
      margin: '0 !important',
    },
    '.MuiFilledInput-input': {
      padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(0.5)} `,
    },
  },
  amountRange: {
    display: 'flex',
    gap: 0,
    '#amount-match-amount1 .MuiInputBase-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '#amount-match-amount2': {
      marginLeft: -1,
      '.MuiInputBase-root': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },
  },
  textPaddingBefore: {
    marginLeft: theme.spacing(1),
  },
  highlightText: {
    color: theme.palette.primary.main,
  },
  infoIcon: {
    color: theme.palette.icon.light,
    height: theme.spacing(1.5),
    width: theme.spacing(1.5),
  },
  infoIcon16: {
    color: theme.palette.icon.light,
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
  infoIcon18: {
    color: theme.palette.icon.light,
    height: theme.spacing(2.25),
    width: theme.spacing(2.25),
  },
  inputStyle: {
    textAlign: 'left',
    padding: 0,
  },
  textField: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    border: `1px ${theme.palette.border.main} solid`,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '& .MuiIconButton-root, & .MuiSvgIcon-root': {
      height: theme.spacing(3),
      width: theme.spacing(3),
    },
  },
  warningIcon: {
    alignSelf: 'top',
    marginRight: 5,
    color: theme.palette.warning.main,
    width: 20,
    height: 20,
  },
  ruleApplicationHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(1.5)}`,
    background: theme.palette.background.paper,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 -1px 2px 0 rgba(0, 0, 0, 0.05)',
    justifyContent: 'space-between',
    borderTopRightRadius: '12px',
    borderTopLeftRadius: '12px',
  },
  noPreviewRules: {
    borderBottomRightRadius: '12px',
    borderBottomLeftRadius: '12px',
  },
  sinceText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  payeeName: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  zeroStateView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyItems: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(7.5),
    gap: theme.spacing(0.5),
  },
  gridContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  previewFooter: {
    borderTop: `1px ${theme.palette.border.main} solid`,
    justifyContent: 'center',
    padding: '32px 0 92px 0',
  },
  sourceAmount: {
    display: 'flex',
    flexDirection: 'row',
    maxHeight: theme.spacing(6.5),
    padding: theme.spacing(2),
  },
  sourceAmountType: {
    display: 'flex',
    flexDirection: 'column',
  },
  sourceAmountValue: {
    display: 'flex',
    flexDirection: 'row',
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.25),
    marginLeft: theme.spacing(1.5),
  },
  errorBorder: {
    '.MuiFilledInput-root': {
      border: `1px solid ${theme.palette.error.main} !important`,
    },
  },
}));

export default useStyles;
